import React from 'react'
import './navigation.css'

import { menuItems } from "./data/meneItems";
import MenuItems from "./MenuItems";
const Navbar = () => {
  return (
    <div style={{height:'100%'}}>
      <ul className="menus">
        {menuItems.map((menu, index) => {
          const depthLevel = 0;
          return <MenuItems items={menu} key={index} depthLevel={depthLevel} />;
        })}
      </ul>
    </div>
  );
};

export default Navbar;